export const patternCity = options => {
    let array = [];

    options.forEach( option => {
        array.push({ value: option.cdMunicipioRegiao, label: option.nmMunicipio })        
    });

    return array;
}

export const patternRegion = options => {
    let array = [];

    options.forEach( option => {
        array.push({ value: option.cdRegiao, label: option.cdRegiao })
    });

    return array;
}

export default patternCity;